import { createRoot } from "@wordpress/element";
import RangeSliderWrapper from "./rangle-slider-wrapper";

document.addEventListener("DOMContentLoaded", () => {
	const filterBlock = document.querySelector(
		'[data-block-name="woocommerce/product-filters"]',
	);

	if (filterBlock) {
	
		initRangeAndEventHandlers();

		const config = { attributes: true, attributeFilter: ["data-wp-context"] };
		//const config = { childList: true, subtree: true };
		const callback = (mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.attributeName === "data-wp-context") {
					// hier kannst du zum Beispiel deinen Slider neu initialisieren
					initRangeAndEventHandlers();
				}
			}
		};

		const observer = new MutationObserver(callback);
		observer.observe(filterBlock, config);
	}
});

function initRangeAndEventHandlers() {
	document.querySelectorAll('.larf-filter-replacer-slider').forEach(el => el.remove());
	document
		.querySelectorAll(".lei-product-attribute-range-filter")
		.forEach((el, index) => {
			
			const sliderContextString = el.dataset.wpContext;
			const sliderContext = JSON.parse(sliderContextString);
			//console.log("sliderContextString: ", sliderContext);
			const filterLabel = sliderContext.activeLabelTemplate?.split(":")[0] || "";
			const filterType = sliderContext.filterType.replace("/", "-");
			const sliderID = `larf-${filterType}`;
			//document.getElementById(sliderID)?.remove()
			const showMoreBtn = el.querySelector("button.wc-block-product-filter-chips__show-more")
			if (showMoreBtn) {
				// show all chips
				showMoreBtn.click();
			}
			const chipItems = el.querySelector(
				".wc-block-product-filter-chips__items",
			);
			// hide default chip items
			if (!chipItems) return;
			chipItems.style.display = "none";

			const slider = document.createElement("div");
			slider.id = sliderID;
			slider.classList.add("larf-filter-replacer-slider");
			el.appendChild(slider);
			const filterValues = Array.from(el.querySelectorAll("button.wc-block-product-filter-chips__item"))
				.map((el) => {
					const contextString = el.dataset.wpContext;
					const context = JSON.parse(contextString);
					//console.log("CHIP CONTEXT: ", context)
					//label: el.getAttribute("aria-label") || "",
					//value: parseFloat(el.value),
					return {
						type: context.item.type,
						label: context.item.label || context.item.ariaLabel,
						value: parseFloat(el.value),
						isSelected: context.item.selected
					};
				})
				.toSorted((a, b) => a.value - b.value);
			console.log("FILTER VALUES: ", filterValues)

			const root = createRoot( slider )
			root.render( <RangeSliderWrapper
				key={index}
				filterLabel={filterLabel}
				filterType={filterType}
				filterValues={filterValues}
				filterElement={el}
			/> );
		});
}
